if (!customElements.get('newsletter-popup')) {
  customElements.define(
    'newsletter-popup',
    class NewsletterPopup extends HTMLElement {
      constructor() {
        super();
        
        const popup = document.getElementById("newsletter_popup");
        const popupoverlay = document.querySelector(".inner_popup_detail");
        if (this.shouldAppearPopup) {
          setTimeout(() => {
              popup.style.display = 'block';
              document.body.classList.add("scroll-hidden");
          }, this.popupDelay);
        }
        
        

        // Detect all clicks on the document
        document.addEventListener("click", function(event) {
            // If user clicks inside the element, do nothing
            if (event.target.closest(".inner_popup_detail")) return;
            popup.style.display = 'none';
            document.body.classList.remove("scroll-hidden");
        });

        
        const closeBtn = document.getElementById("closeBtn");
        closeBtn.addEventListener('click', ()=>{
           popup.style.display = 'none';
           document.body.classList.remove("scroll-hidden");
        });
        
       
      }
      get popupDelay() {
        return parseInt(this.getAttribute("data-popupdelay") || 0) * 1e3;
      }
      get shouldAppearPopup() {
        return !(localStorage.getItem("theme:newsletterPopup-filled") === "true" ||  localStorage.getItem("theme:popup-shown") === "true");
      }
     
     
    }
  );
}